//引入axios
import axios from 'axios'
import {Message} from 'view-design'
import router from '../router'
import {refreshToken} from '@/utils/api.js'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const isToken = true;

//创建sxios对象
const service = axios.create({
  	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseUrl:"https://www.xishen.top/",
	//baseUrl:"http://www.tp5.com/",
	timeout:6000000
});

//请求拦截器
service.interceptors.request.use(config=>{
	// 是否需要设置 token
  	if(isToken){
  		const token = sessionStorage.getItem('token');
  		
  		config.headers.token = token;
  	}
  	
  	config._isRefresh = config._isRefresh || false;
	return config;
},(error)=>{
	return Promise.reject(error);
})

//响应拦截器
service.interceptors.response.use(async (res)=>{
	if(res.data.code == 200){
		//请求成功
		return Promise.resolve(res.data.data);
	}else if(res.data.code == 401){
		//token失效  用失效的token换取新token
		res.config._isRefresh = true;
		
		if(res.config._isRefresh){
			await refreshToken();
			res.config._isRefresh = false;
		}else{
			return await service.request(res.config);
		}
	}else if(res.data.code == 400){
		//全部失效 重新登录
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('is_login');
		
		router.push({path:'/login'});
	}else{
		Message.warning(res.data.msg);
		
		return Promise.reject(res.data.msg);
	}
},(error)=>{
	let texts = error.message || error.response.statusText != undefined || '网络错误，请稍后再试';
	Message.error(texts);
	return Promise.reject(error);
})

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js